import React, { useState, useEffect } from "react";

import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>
        All Copyrights reserved by{" "}
        <a target="_blank" href="https://aircheats.github.io/">
          AIRCH3ATS
        </a>{" "}
        ©️ 2022
      </p>
      {/* <p className="credits">
        Design with <i className="fas fa-heart"></i>{" "}
        <a target="_blank" href="https://github.com/aircheats">
          
        </a>
      </p> */}
    </div>
  );
};

export default Footer;
